
import 'helpers/error-reporter'

import Vue from 'vue'
import ErrorHandler from 'helpers/error-handler'
Vue.use(ErrorHandler)

// Quasar Framework
import './quasar.styl'
import 'quasar-framework/dist/quasar.ie.polyfills'
import quasar_i18n from 'quasar-framework/i18n/ja'
import 'quasar-extras/animate'
import 'quasar-extras/material-icons'
import {
  Quasar,
  QBtn,
  QBtnDropdown,
  QContextMenu,
  QField,
  QIcon,
  QInput,
  QLayout,
  QLayoutDrawer,
  QLayoutHeader,
  QPage,
  QPageContainer,
  QItem,
  QItemSeparator,
  QItemMain,
  QItemSide,
  QItemTile,
  QList,
  QListHeader,
  QModal,
  QSlider,
  QToggle,
  QToolbar,
  QToolbarTitle,
  QTooltip,
  CloseOverlay,
  Dialog,
  Loading,
  Notify,
} from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: {
    QBtn,
    QBtnDropdown,
    QContextMenu,
    QField,
    QIcon,
    QInput,
    QLayout,
    QLayoutDrawer,
    QLayoutHeader,
    QPage,
    QPageContainer,
    QItem,
    QItemSeparator,
    QItemMain,
    QItemSide,
    QItemTile,
    QList,
    QListHeader,
    QModal,
    QSlider,
    QToggle,
    QToolbar,
    QToolbarTitle,
    QTooltip,
  },
  directives: {
    CloseOverlay,
  },
  plugins: {
    Dialog,
    Loading,
    Notify,
  },
  i18n: quasar_i18n,
})

//
import 'bootstrap/index.js'
